import { SVGProps } from 'react';

import { useAccent } from 'hooks';
import { Accent } from 'utils/steps';

import {
  CheckboxOn,
  RadioChecked,
  CheckboxOnPurple,
  RadioCheckedPurple,
} from './icons';

export const RadioCheckedIcon = (props: SVGProps<SVGSVGElement>) => {
  const Icon =
    useAccent() === Accent.Purple ? RadioCheckedPurple : RadioChecked;
  return <Icon {...props} />;
};

export const CheckboxOnIcon = (props: SVGProps<SVGSVGElement>) => {
  const Icon = useAccent() === Accent.Purple ? CheckboxOnPurple : CheckboxOn;
  return <Icon {...props} />;
};
